import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { showNotification, successNofication } from "src/shared/components/Notification";
import PndRestApi from "src/utils/pnd/PndRestApi";
import ResetPassword from "./UpdateResetPassword";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, LOGIN_HUB_USER_IDENTIFIER } from "src/utils/pnd/PndConstants";
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import { CircularProgress } from '@mui/material';

const ModalPasswordReset = ({ modalShow, setModalShow, isTitle, userData }) => {
  const [isRedirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = () => {
    if (!loading) {
      setModalShow(prevState => !prevState);
    }
  };

  if (isRedirect) {
    window.location.reload();
    return <Redirect to='/web_app/user_management/create_user/view' />;
  }

  const handleSubmit = async (formValues) => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append('newPassword', formValues["password"]);
      formData.append('userId', userData?.userId);
      formData.append('type', LOGIN_HUB_USER_IDENTIFIER); // 2 - hub users 

      if (formData) {
        const response = await PndRestApi.ResetPassword(formData);
        if (response.status === 200 && response.data.status === 200) {
          successNofication(
            "theme-light",
            "ltr",
            `SuccessCode: 200`,
            `Message: Hub user's password has been updated successfully.`,
          );
          setModalShow(false);
          setRedirect(true);
        } else {
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: ${response.data.status}`,
            `Message:${response.data.message}`,
          );
          setLoading(false);
          return;
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalShow}
        toggle={toggle}
        modalClassName="ltr-support"
        className="theme-light ltr-support"
        size="md"
        backdrop={loading ? "static" : true}
        style={{ maxWidth: '550px', border: 'none' }}
      >
        {/* Modern Premium Modal Header */}
        <div
          className="position-relative"
          style={{
            background: 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)',
            padding: '1.25rem 1.75rem',
            borderRadius: '8px 8px 0 0',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center me-3"
                style={{
                  width: '42px',
                  height: '42px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '10px',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <LockIcon style={{ fontSize: '22px', color: '#fff' }} />
              </div>
              <div>
                <h4
                  className="m-0 text-white fw-bold text-uppercase"
                  style={{
                    fontSize: '1.2rem',
                    letterSpacing: '0.5px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  {isTitle || "Password Reset"}
                </h4>
                <p className="m-0 text-white-50 small mt-0.5" style={{ fontSize: '0.8rem' }}>
                  Securely update account credentials
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={toggle}
              disabled={loading}
              className="btn-close-custom"
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                opacity: loading ? 0.5 : 1
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'rotate(90deg)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.transform = 'rotate(0deg)';
              }}
            >
              <CloseIcon style={{ color: '#fff', fontSize: '18px' }} />
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <ModalBody className="p-0" style={{ background: '#f8fafc', borderRadius: '0 0 8px 8px' }}>
          {loading && (
            <div
              className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                background: 'rgba(255,255,255,0.85)',
                zIndex: 1050,
                backdropFilter: 'blur(4px)',
                borderRadius: '0 0 8px 8px'
              }}
            >
              <div className="text-center">
                <CircularProgress size={45} style={{ color: '#0284c7' }} />
                <p className="mt-2 text-muted fw-bold small">Updating Password...</p>
              </div>
            </div>
          )}

          <div className="p-4">
            <ResetPassword userData={userData} onSubmit={handleSubmit} />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

ModalPasswordReset.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired,
  isTitle: PropTypes.string,
  userData: PropTypes.object,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModalPasswordReset);
